import { render } from "./recurring_todo_tooltip_icon.svg?vue&type=template&id=6f7bfc64&scoped=true&component"
const script = {  }

import "./recurring_todo_tooltip_icon.svg?vue&type=style&index=0&id=6f7bfc64&scoped=true&lang=css&component"

import exportComponent from "../../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f7bfc64"]])

export default __exports__